import { HelpTip } from './HelpTip';

interface MeterProps {
  label: string;
  value: number;
  max: number;
  tone: 'health' | 'energy' | 'heat' | 'block';
  display?: string;
  warning?: string;
  help?: string;
}

export function Meter({ label, value, max, tone, display, warning, help }: MeterProps) {
  return (
    <div className={`meter meter--${tone}`}>
      <span className="meter__label">{help ? <HelpTip label={label}>{help}</HelpTip> : label}</span>
      <strong className="meter__value">{display ?? `${value}/${max}`}</strong>
      <progress value={value} max={max} aria-label={`${label}: ${display ?? `${value} of ${max}`}`} />
      {warning ? <span className="meter__warning">{warning}</span> : null}
    </div>
  );
}

export function HeatGauge({ heat, overheatDamage = 3 }: { heat: number; overheatDamage?: number }) {
  return (
    <div className={`heat-gauge${heat === 6 ? ' is-critical' : ''}`}>
      <span className="heat-gauge__heading">
        <span><HelpTip label="Heat">Stoke raises Heat; Temper spends it for stronger effects. End a turn at 6 Heat and lose {overheatDamage} HP through Block, then cool to 3. This damage includes your relics.</HelpTip></span>
        <strong>{heat}/6</strong>
      </span>
      <span className="heat-gauge__segments" aria-label={`Heat: ${heat} of 6`} role="meter" aria-valuemin={0} aria-valuemax={6} aria-valuenow={heat}>
        {Array.from({ length: 6 }, (_, index) => (
          <i key={index} className={index < heat ? 'is-lit' : ''} aria-hidden="true" />
        ))}
      </span>
      <span className="heat-gauge__hint">
        {heat === 6 ? `Overheat: lose ${overheatDamage} HP when the turn ends` : 'Stoke for power. Temper to cool.'}
      </span>
    </div>
  );
}
